import TokenVerificationTemplate from './TokenVerificationTemplate';

import logo from '../../../../node_modules/@deere/ux.brand-foundations/logos/jdf-logo-green.svg';
import i18n from '../../../i18n';
import {getAPICall, postAPICall} from '../../../services/apiCallsHandler';
import Footer from '../../footer/Footer';
import VerifyPassword from '../password/VerifyPassword';

import {Alert, Form, Spinner} from '@deere/ux.uxframe-react';
import React, {useState} from 'react';
import './SetOrgPassword.css';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

const SetOrgPassword = (props) => {
  const location = useLocation();
  const {t} = useTranslation();
  const [isAlert, setIsAlert] = useState(false);
  const [alertType, setAlertType] = useState('danger');
  const [newPassword, setNewPassword] = useState('');
  const [isSetPasswordDisabled, setIsSetPasswordDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tokenVerified, setTokenVerified] = useState(false);
  const [verificationId, setVerificationId] = useState(null);
  const [firstTimeLogin, setFirstTimeLogin] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const successHandler = () => {
    setIsAlert(true);
    setAlertType('success');
    setTimeout(() => (window.location.href = '/login'), 8000);
  };

  const errorHandler = () => {
    setIsAlert(true);
    setIsError(true);
    setAlertType('danger');
    setIsLoading(false);
    setTimeout(() => {
      setIsAlert(false);
    }, 3000);
  };

  const changePassword = async () => {
    setIsLoading(true);
    setIsError(false);
    setIsSetPasswordDisabled(true);
    verificationId &&
      postAPICall(
        'setOrgNewPassword?verificationId=' + verificationId,
        {
          newPassword,
        },
        {
          errorTag: 'CHANGE_PASSWORD_ERROR',
          logInfoMsg: 'Error occured while changing password',
        }
      ).then((response) => {
        if (response.statusCode === 200) {
          successHandler();
        } else {
          errorHandler();
        }
      });
  };

  const renderTokenVerificationTemplate = (h) => {
    return (
      <TokenVerificationTemplate
        tokenVerified={tokenVerified}
        firstTimeLogin={firstTimeLogin}
      />
    );
  };

  const showAlert = (variant) => {
    return (
      <Alert
        className="alertOnLogin SetOrgPasswordAlert"
        id="verifyEmailAlert"
        variant={variant}
        aria-atomic="true"
        show={true}
        transition={true}
      >
        <h5 className="uxf-alert-title">
          {variant === 'danger'
            ? i18n.t('PASSWORD_RESET_ERROR')
            : i18n.t('PASSWORD_RESET_SUCCESS')}
        </h5>
        <p className="uxf-alert-description">
          {variant === 'danger'
            ? i18n.t('POST_API_ERR_MSG')
            : i18n.t('PASSWORD_RESET')}
        </p>
      </Alert>
    );
  };

  const changeLanguage = async () => {
    await i18n.changeLanguage(
      localStorage.getItem('mfalancode')
        ? localStorage.getItem('mfalancode')
        : 'en'
    );
  };

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('verificationId');

    if (!token) return;
    changeLanguage();
    let type = 'setOrgPassword';
    token &&
      getAPICall(
        `validateEmail?verificationId=${token}&type=${type}`,
        {
          isCallBack: false,
          errorTag: 'TOKEN_VERIFY_DETAILS',
          logInfoMsg: 'invoke Offer eligibility details',
        },
        {}
      ).then(async (data) => {
        if (data && data.body && data.body.verification == 'success') {
          data.body.firstTimeLogin && setFirstTimeLogin(true);
          setVerificationId(data.body.verificationId);
          setTokenVerified(data.body.verification);
          setSkeletonLoading(false);
        } else if (data && data.body && data.body.verification == 'expired') {
          setTokenVerified(data.body.verification);
          setSkeletonLoading(false);
        } else {
          setTokenVerified('failed');
          setSkeletonLoading(false);
        }
      });
  }, []);

  return (
    <>
      {skeletonLoading ? (
        <Spinner />
      ) : tokenVerified && tokenVerified != 'success' ? (
        renderTokenVerificationTemplate()
      ) : firstTimeLogin ? (
        renderTokenVerificationTemplate()
      ) : (
        <div className="Login">
          <img className="LoginLogo" id="login-page" src={logo} alt="logo" />
          {isAlert && showAlert(alertType)}
          <div id="passwordChallenge" className="setOrgPasswordContainer">
            <div className="heading">{i18n.t('SET_NEW_PASSWORD')}</div>
            <Form>
              <Form.Group>
                <VerifyPassword
                  setUpdatedPassword={setNewPassword}
                  setIsSetPasswordDisabled={setIsSetPasswordDisabled}
                  isDisabled={isSetPasswordDisabled}
                  handleSubmit={changePassword}
                  isLoading={isLoading}
                  isError={isError}
                  buttonText={i18n.t('SET_PASSWORD')}
                />
              </Form.Group>
            </Form>
          </div>
          <Footer className="LoginFooter" isShowList={true} />
        </div>
      )}
    </>
  );
};

export default SetOrgPassword;
